export default __webpack_public_path__ + "static/hf-2-22b315729ce237fc041eff0a7212c555.png";